import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,{attrs:{"label":"","outline":"","color":_vm.statusColor}},[_c('span',{staticClass:"text-none"},[_vm._v(_vm._s(_vm.statusText))])])}
var staticRenderFns = []

export { render, staticRenderFns }